"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identifyExponeaUser = void 0;
var _js = require("@adeira/js");
const identifyExponeaUser = (email, userId) => {
  var _window$infinario;
  if ((0, _js.isBrowser)() && typeof ((_window$infinario = window.infinario) === null || _window$infinario === void 0 ? void 0 : _window$infinario.identify) === "function") {
    window.infinario.identify({
      email_id: email,
      visitorId: userId
    });
  }
};
exports.identifyExponeaUser = identifyExponeaUser;